import {defaultThemeFontsNewDesign} from "./Fonts";
import {defaultThemeNewDesignColors} from "./DefaultColors";

export const defaultTheme = {
    colors: defaultThemeNewDesignColors,
    fonts: defaultThemeFontsNewDesign,
};
